export default __webpack_public_path__ + "static/media/bg.280a85eb.png";